const MODULE = "lancer-initiative";

export async function addCurrentActivations(combatant, n) {
  return combatant.setFlag(
    MODULE,
    "activations.value",
    (combatant.getFlag(MODULE, "activations.value") ?? 0) + n
  );
}

export async function addMaxActivations(combatant, n) {
  const { value = 0, max = 0 } = combatant.getFlag(MODULE, "activations") ?? {};
  return combatant.setFlag(MODULE, "activations", {
    value: Math.clamp(value + n, 0, max + n),
    max: Math.max(0, max + n),
  });
}

export function getDisposition(combatant) {
  const disposition =
    combatant.getFlag(MODULE, "disposition") ??
    combatant.token?.disposition ??
    combatant.actor?.prototypeToken.disposition ??
    -2;
  if (disposition === CONST.TOKEN_DISPOSITIONS.FRIENDLY && combatant.hasPlayerOwner) return 2;
  return disposition;
}

export function prepareBaseData(wrapped) {
  wrapped();
  const activations = Math.round(
    foundry.dice.Roll.safeEval(
      foundry.dice.Roll.replaceFormulaData(
        game.settings.get(MODULE, "activations-formula"),
        this.actor?.getRollData() ?? {}
      )
    )
  );
  if (!game.settings.get(MODULE, "combat-tracker-enable-initiative")) this.initiative ??= 0;
  foundry.utils.mergeObject(
    this.flags,
    {
      "lancer-initiative.activations.value": this.parent?.started ? activations : 0,
      "lancer-initiative.activations.max": activations,
    },
    { overwrite: false }
  );
}
